import { Icon } from '@chakra-ui/react';

export default function ClockIcon(props) {
  return (
    <Icon
      width='24'
      height='25'
      viewBox='0 0 24 25'
      fill='currentColor'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path d='M12 24.4922C5.47266 24.4922 0.046875 19.0664 0.046875 12.5391C0.046875 6 5.46094 0.585938 11.9883 0.585938C18.5273 0.585938 23.9531 6 23.9531 12.5391C23.9531 19.0664 18.5391 24.4922 12 24.4922ZM12 22.5C17.5312 22.5 21.9609 18.0703 21.9609 12.5391C21.9609 7.00781 17.5195 2.57812 11.9883 2.57812C6.45703 2.57812 2.05078 7.00781 2.05078 12.5391C2.05078 18.0703 6.46875 22.5 12 22.5ZM5.87109 13.8047C5.40234 13.8047 5.05078 13.4531 5.05078 12.9844C5.05078 12.5273 5.40234 12.1758 5.87109 12.1758H11.1797V5.08594C11.1797 4.62891 11.5312 4.27734 11.9883 4.27734C12.4453 4.27734 12.8086 4.62891 12.8086 5.08594V12.9844C12.8086 13.4531 12.4453 13.8047 11.9883 13.8047H5.87109Z' />
    </Icon>
  );
}
